import { Preview } from "@creatomate/preview";

import { Organization, Story, Template } from "chq";

import deleteElement from "./deleteElement";
import { IMAGE_TYPE, VIDEO_TYPE } from "../constants";
import setMontageCustomTemplate from "./setMontageCustomTemplate";
import getDefaultSource from "./getDefaultSource";

const isHttpsUrl = (url: string | undefined): boolean => url !== undefined && url.startsWith("https://");
const isValidMediaType = (type: string | undefined): boolean => (
  type === VIDEO_TYPE || type === IMAGE_TYPE
);
const isNotLogo = (name: string | undefined): boolean => name === undefined || !name.toLowerCase().includes("logo");
const isNotAsset = (url: string): boolean => !url.toLowerCase().includes("culturehq-assets"); // intros or outros videos

const getMediaElements = (preview: Preview) => (
  preview.state?.elements.filter(({ source }) => isHttpsUrl(source.source)
    && isValidMediaType(source.type) && isNotLogo(source.name) && isNotAsset(source.source)
  )
);

const setMontageTemplate = async (
  preview: Preview,
  organization: Organization,
  selectedStories: Story[],
  onStoryUpdate?: (story: Story) => void,
  trend?: string,
  template?: Template
): Promise<void> => {
  const mediaElements = getMediaElements(preview);

  if (template) {
    await preview.loadTemplate(template.value);
    if (onStoryUpdate) {
      await setMontageCustomTemplate(
        template, preview, organization, trend, selectedStories, onStoryUpdate, mediaElements
      );
    }
  } else {
    const elements = preview.state?.elements || [];
    for (let index = 0; index < elements.length; index += 1) {
      const element = elements[index];
      // eslint-disable-next-line no-await-in-loop
      await deleteElement(preview, element.source.id);
    }
    await preview.setSource(await getDefaultSource({ mediaElements, organization, preview }));
  }
};

export default setMontageTemplate;
